import { use_slice_user } from '@/hooks/store/use_slices';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';

interface Props {
  field: FIELD__token;
  truncate?: boolean;
  line_clamp?: boolean;
}

export default function UI_SHARED_LABEL__token({ field, truncate = false, line_clamp = false }: Props) {
  const { user_settings } = use_slice_user(['user_settings']);

  let value_string = field.get_word_string(user_settings.regional_language, user_settings.regional_use_english_tokens_in_prompt);

  /*
   * HTML
   */
  return (
    <p
      className={`w-full 
                  text-left leading-tight
                  ${truncate && 'truncate'}
                  ${line_clamp && 'line-clamp-3'}
    `}
    >
      {value_string}
    </p>
  );
}
